module.exports = __webpack_public_path__ + "img/success.43d50d5b.png";